module.exports = __webpack_public_path__ + "img/icon_close.e3fc0e65.svg";